import React from "react";
import {useNavigate} from "react-router-dom";
import {Header, StyledCard, Subtext,} from "./CheckYourMailbox.styled";
import {AuthContainer} from "../Auth.styled";
import {brand} from "../../../theme/brand";
import {usePageTitle} from '../../../hooks/usePageTitle';
import {PageTitleKeys} from '../../../config/routeConstants';
import {useTranslation} from 'react-i18next';
import LogoWithLanguageSwitcher from '../../../components/common/LogoWithLanguageSwitcher';
import {Button} from "@mui/material";

const CheckYourInbox = () => {
    usePageTitle(PageTitleKeys.CheckMailbox);
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <AuthContainer role="region" aria-labelledby="check-mailbox-title">
            <LogoWithLanguageSwitcher src={brand.logo} alt={t('auth.logo.alt')} clickable={false} />

            <StyledCard>
                <Header id="check-mailbox-title">{t('checkMailbox.title')}</Header>
                <Subtext>{t('checkMailbox.subtitle')}</Subtext>

                <Button variant="contained" fullWidth onClick={() => navigate("/login")} aria-label={t('checkMailbox.backButton.ariaLabel') as string}>
                    {t('checkMailbox.backButton')}
                </Button>
            </StyledCard>
        </AuthContainer>
    );
};

export default CheckYourInbox;
